var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AgencyService } from './../api/agency.service';
import { OnInit, Injector } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PropertySearch } from '../models/index';
import { AbstractPropertiesSearch } from './shared/index';
var HousesBaseComponent = /** @class */ (function (_super) {
    __extends(HousesBaseComponent, _super);
    function HousesBaseComponent(injector, agencyService, route, window, document) {
        var _this = _super.call(this, injector, window) || this;
        _this.agencyService = agencyService;
        _this.route = route;
        _this.window = window;
        _this.document = document;
        _this.properties = [];
        _this.type = 'project';
        return _this;
    }
    HousesBaseComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.apiLoading = true;
        this.route.data.forEach(function (data) {
            if (data.advanced_limits)
                _this.advancedLimits = data.advanced_limits;
            if (data.property_search)
                _this.routePropertySearch = data.property_search;
            AbstractPropertiesSearch.propertySearch = new PropertySearch();
            _this.currentPropertyType = data.property_type;
            _this.type = 'house';
        });
        this.subscription.add(this.route.queryParams
            .subscribe(function (params) {
            _this.validateRouteQueryParams(params);
            AbstractPropertiesSearch.propertySearch = _this.propertyService.decodeUrlParams(params, _this.advancedLimits);
            AbstractPropertiesSearch.propertySearch.property_type = _this.currentPropertyType;
            if (_this.routePropertySearch)
                for (var field in _this.routePropertySearch)
                    if (_this.routePropertySearch.hasOwnProperty(field)
                        && _this.routePropertySearch[field]
                        && field.length
                        && AbstractPropertiesSearch.propertySearch.hasOwnProperty(field)
                        && AbstractPropertiesSearch.propertySearch[field] === null)
                        AbstractPropertiesSearch.propertySearch[field] = _this.routePropertySearch[field];
            _this.refreshProperties();
        }));
        this.setTitle('Locuinte ' + this.agencyService.agency.name);
    };
    HousesBaseComponent.prototype.updatePropertySearch = function (fieldName, fieldValue) {
        AbstractPropertiesSearch.propertySearch[fieldName] = fieldValue;
        this.refreshProperties();
    };
    HousesBaseComponent.prototype.getCurrentScrollPosition = function () {
        return Math.max(this.document.body.scrollTop, this.document.documentElement.scrollTop);
    };
    return HousesBaseComponent;
}(AbstractPropertiesSearch));
export { HousesBaseComponent };



// WEBPACK FOOTER //
// ./src/app/common-theme/base-components/houses-base.component.ts.pre-build-optimizer.js